import React from 'react';
import { fromUnixTime } from 'date-fns';
import { Badges } from '../Badges';
import { hasSaleStarted } from '../Edition/useMintState';
import type { ScheduleWithTierInfo } from './data';
import {
  getCollectedAmount,
  getMaxSupply,
  getMintExpiry,
  getSaleType,
  hasSaleEnded,
  isScheduleSoldOut,
} from './data';

export const TiersBadges = ({ schedule }: { schedule: ScheduleWithTierInfo }) => {
  const saleType = getSaleType(schedule);
  const isOpenEdition = saleType === 'open-edition';

  const isSaleRunning = hasSaleStarted({
    startTimestamp: schedule.startTime,
  });

  const isSoldOut = isScheduleSoldOut({
    schedule,
  });

  const saleEnded = hasSaleEnded({
    schedule,
  });

  const isPresale = schedule.mode === 'VERIFY_MERKLE';

  const totalMinted = getCollectedAmount({ schedule });
  const maxValue = getMaxSupply(schedule);

  return (
    <Badges
      isOpenEdition={isOpenEdition}
      isSaleRunning={isSaleRunning}
      isSoldOut={isSoldOut}
      saleEnded={saleEnded}
      isPresale={isPresale}
      expiryTimestamp={fromUnixTime(getMintExpiry(schedule)).getTime()}
      totalMinted={totalMinted}
      maxValue={maxValue}
    />
  );
};
